import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NormalInput2 from "../../components/inputs/NormalInput2";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import CategoriesSelectInput from "../../components/inputs/CategoriesSelectInput";
import AvailabililityInput from "../../components/inputs/AvailabililityInput";
import AddressModal from "../../components/modals/AddressModal";
import DiscountModal from "../../components/modals/DiscountModal";
import ImagesUploadInput from "../../components/inputs/ImagesUploadInput";
import ImageUploadInput from "../../components/inputs/ImageUploadInput";
import VideoUploadInput from "../../components/inputs/VideoUploadInput";
import ThankYouModal from "../../components/modals/ThankYouModal";
import { useGoBack } from "../../utils";
import NormalInput from "../../components/inputs/NormalInput";
import SimpleDropdownInput from "../../components/inputs/SimpleDropdownInput";
import SimpleDropdownInput2 from "../../components/inputs/SimpleDropdownInput2";
import SimpleDropdownInput3 from "../../components/inputs/SimpleDropdownInput3";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
import StripePaymentModal from "../../components/modals/StripePaymentModal";
import { GooglePlacesInput } from "../../components/inputs/GooglePlacesInput";
import { LoadScript } from "@react-google-maps/api";
import { types } from "../../dummyData";
import { useTranslation } from "../../languages";
const AddPlace = () => {
  const goBack = useGoBack();
  const {
    /// all local states
    placeData,
    setPlaceData,
    thankYouModalOpen,
    setThankYouModalOpen,
    stripeModalOpen,
    setStripeModalOpen,
    clientSecret,
    //all validations
    isFormValid,
    /// all functions
    onPressPlacesPayBtn,
    copyLocationDetailsToBilling
  } = usePlaceHooks();
  const { t } = useTranslation();
  return (
    <div>
      <Container fluid>
        <Header title={t("myPlaces")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-7 color-primary-blue m-0 figma-font-h5">
            {t('addNewPlace')}
          </h5>
          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            {t("close")}
          </Button>
        </div>
        <Card className="border-none figma-card-radius p-0">
          <CardBody className="padding-top-42px padding-left-42px padding-right-42px">
            <Row
              style={{ "--bs-gutter-y": "1.5rem" }}
            // className=" justify-content-center"
            >
              <Col md={6}>
                <NormalInput2
                  placeholder={t('enterYourPlaceName')}
                  value={placeData?.name}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, name: v }))
                  }
                  label={t('writeNameForPlace')}
                />
              </Col>
              <Col md={6}>
                <MultiSelectInput
                  label={t('type')}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, types: v }))
                  }
                  options={types}
                  value={placeData?.types ?? []}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={t("link")}
                  placeholder={t("writeReservationLinkHere")}
                  value={placeData?.reservationLink}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, reservationLink: v }))
                  }
                  label={t("reservationLink")}
                />
              </Col>
              <Col md={6}>
                <AvailabililityInput
                  label={t("availability")}
                  value={placeData?.availability}
                  setAvailabilityValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, availability: v }))
                  }
                  t={t}
                />
              </Col>
              <Col md={6}>
                <DiscountModal
                  label={t("offeredDiscounts")}
                  value={placeData?.offers}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, offers: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <AddressModal
                  label={t("location")}
                  value={placeData?.location}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, location: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"text"}
                  value={placeData?.companyName}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, companyName: v }))
                  }
                  label={t("companyName")}
                  placeholder={t("writeCompanyNameHere")}
                />
              </Col>
              <Col md={6}>
                <AddressModal
                  label={t("billingAddress")}
                  title={t("addBillingAddress")}
                  value={placeData?.billingAddress}
                  setValue={(v) =>
                    console.log("this is val", v) ||
                    setPlaceData((prev) => ({ ...prev, billingAddress: v }))
                  }
                  copy={true}
                  copyLocationDetailsToBilling={copyLocationDetailsToBilling}
                  placeData={placeData}
                />
              </Col>
              {/* <Col md={6}>
                <NormalInput2
                  type={"url"}
                  value={placeData?.website}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, website: v }))
                  }
                  label={"Website Link"}
                  placeholder={"Write website link here"}
                />
              </Col> */}
              <Col md={6}>
                <Label
                  style={{ marginBottom: "0.5rem" }}
                  className="figma-input-label d-block"
                >
                  {t("genderPreference")}
                </Label>
                <SimpleDropdownInput3
                  placeholder={t("selectOption")}
                  options={[t("male"), t("female"),t("All")]}
                  value={placeData?.genderPreference}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, genderPreference: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <CategoriesSelectInput
                  label={t("category")}
                  arrayValue={placeData?.categories ?? []}
                  setArrayValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, categories: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <NormalInput2
                  label={t("enterDescription")}
                  type={"textarea"}
                  placeholder={"Write description of place"}
                  value={placeData?.description ?? ""}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, description: v }))
                  }
                />
              </Col>
              <Col md={12} xl={4}>
                <ImagesUploadInput
                  label={t("addPhotos")}
                  value={placeData?.photos}
                  maxImages={4}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, photos: v }))
                  }
                />
              </Col>
              <Col xl={4} md={6}>
                <Label
                  className="figma-input-label d-block"
                  style={{ marginBottom: "0.9rem" }}
                >
                  {t("addVideo")}
                </Label>
                <div style={{ maxWidth: "250px" }}>
                  <VideoUploadInput
                    noPadding={true}
                    hideShadow={true}
                    id={"place-video"}
                    setValue={(v) =>
                      setPlaceData((prev) => ({ ...prev, videos: v }))
                    }
                    value={placeData?.videos}
                  />
                </div>
              </Col>
              <Col xl={4} md={6}>
                {/* <SimpleDropdownInput3
                  placeholder={"Select Option"}
                  options={["Menu"]}
                  value={placeData?.menuOption}
                  setValue={(v) =>
                    setPlaceData((prev) => ({ ...prev, menuOption: v }))
                  }
                /> */}
                <div className="mt-3  flex-wrap justify-content-end gap-2">
                  <Label
                    style={{ marginBottom: "0.9rem" }}
                    className="figma-input-label d-block"
                  >
                    {t("addMenu")}
                  </Label>
                  <div style={{ width: "100%", maxWidth: "200px" }}>
                    <ImageUploadInput
                      id={"place-menu"}
                      setValue={(v) =>
                        setPlaceData((prev) => ({ ...prev, menuImages: v }))
                      }
                      value={placeData?.menuImages}
                    />
                  </div>
                </div>
              </Col>
              <div className="mt-5 mb-2 text-center">
                <Button
                  style={{ maxWidth: "380px" }}
                  onClick={onPressPlacesPayBtn}
                  className="standard-rounded-btn full-width"
                  disabled={!isFormValid}
                >
                  {t("payNow")}
                </Button>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Container>
      {/* thank you modal */}
      <ThankYouModal
        isOpen={thankYouModalOpen}
        setisOpen={setThankYouModalOpen}
      />
      <StripePaymentModal
        isOpen={stripeModalOpen}
        toggle={() => setStripeModalOpen(!stripeModalOpen)}
        clientSecret={clientSecret}
        onPaymentSuccess={() => {
          setThankYouModalOpen(true); // show thank you modal
          setStripeModalOpen(false); // close payment modal
        }}
      />
    </div>
  );
};
export default AddPlace;
